<script>
import lazysizes from "lazysizes";
import Sidebar from "./components/Sidebar";
import Result from "./components/Result";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "app",
  components: {
    Sidebar,
    Result,
  },

  computed: {
    ...mapGetters({
      urlPrefix: "getUrlPrefix",
      paramsUrls: "getDataParams",
      filterUrlPrefix: "getFilterUrlPrefix",
      tourCategoryId: "getTourCategoryId",
      loading: "getLoading",
    }),
  },

  methods: {
    ...mapActions(["fetchFilterData", "fetchFilters"]),
  },

  created() {
    lazysizes.init();

    this.fetchFilterData(this.urlPrefix + this.tourCategoryId);
  },
};
</script>

<style lang="scss">
@import "./style/modules/_tourList.scss";
</style>

<template>
  <div class="container px--0">
    <div class="c-tour-list">
      <div class="tour-list">
        <Sidebar />

        <Result />
      </div>
    </div>
  </div>
</template>
